import { z } from "zod";
/** Every theme the app offers; the app's theme options must list exactly these. */
export const APP_THEME_IDS = [
    "theme-light-blue",
    "theme-light",
    "theme-editorial",
    "theme-light-violet",
    "theme-light-teal",
    "theme-light-green",
    "theme-light-rose",
    "theme-charcoal",
    "theme-charcoal-blue",
    "theme-charcoal-violet",
    "theme-charcoal-teal",
    "theme-charcoal-green",
    "theme-charcoal-rose",
    "theme-charcoal-editorial",
    "dark",
    "theme-dark-blue",
    "theme-dark-violet",
    "theme-dark-teal",
    "theme-dark-green",
    "theme-dark-rose",
    "theme-dark-editorial",
];
/** "system" follows the device between a light and a dark theme. */
export const appThemeChoiceSchema = z.enum([...APP_THEME_IDS, "system"]);
/** How the workspace opens pages: one at a time, or as tabs in split, resizable panes. */
export const WORKSPACE_LAYOUTS = ["pages", "tabs"];
export const workspaceLayoutSchema = z.enum(WORKSPACE_LAYOUTS);
/** A signed-in person's preferences; each is null until they save it (a null layout reads as pages). */
export const workspacePreferencesResponseSchema = z.object({
    appTheme: appThemeChoiceSchema.nullable(),
    workspaceLayout: workspaceLayoutSchema.nullable(),
});
/** Saves one preference or both; one left out keeps what was saved. */
export const workspacePreferencesUpdateSchema = z.object({
    appTheme: appThemeChoiceSchema.optional(),
    workspaceLayout: workspaceLayoutSchema.optional(),
}).strict().refine((update) => update.appTheme !== undefined || update.workspaceLayout !== undefined, { message: "Name a preference to save." });
